import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Row } from 'reactstrap';
import { without, range } from 'underscore';
import Checkbox from '../field/checkbox';

const checkboxes = [
  {
    label: 'Any',
    value: ''
  },
  {
    value: 'ABR',
    label: 'ABR -- Accredited Buyer Representative'
  },
  {
    value: 'ABRM',
    label: 'ABRM -- Accredited Buyer Representative Manager'
  },
  {
    value: 'AHWD',
    label: 'AHWD -- At Home With Diversity'
  },
  {
    value: 'ALC',
    label: 'ALC -- Accredited Land Consultant'
  },
  {
    value: 'CCIM',
    label: 'CCIM -- Certified Commercial Investment Member'
  },
  {
    value: 'CIPS',
    label: 'CIPS -- Certified International Property Specialist'
  },
  {
    value: 'CPM',
    label: 'CPM -- Certified Property Manager'
  },
  {
    value: 'CRB',
    label: 'CRB -- Certified Real Estate Brokerage Manager'
  },
  {
    value: 'CRE',
    label: 'CRE -- Counselor of Real Estate'
  },
  {
    value: 'CRS',
    label: 'CRS -- Certified Residential Specialist'
  },
  {
    value: 'ePRO',
    label: 'ePRO -- Internet Professional'
  },
  {
    value: 'GREEN',
    label: 'GREEN -- Green Designation'
  },
  {
    value: 'GRI',
    label: 'GRI -- Graduate, REALTOR® Institute'
  },
  {
    value: 'PMN',
    label: 'PMN -- Performance Management Network'
  },
  {
    value: 'REPA',
    label: 'REPA -- Real Estate Professional Assistant'
  },
  {
    value: 'RSPS',
    label: 'RSPS -- Resort &amp; Second-Home Property Specialist'
  },
  {
    value: 'SFR',
    label: 'SFR -- Short Sales &amp; Foreclosures Resource'
  },
  {
    value: 'SIOR',
    label: 'SIOR -- Society of Industrial and Office REALTORS®'
  },
  {
    value: 'SRES',
    label: 'SRES -- Seniors Real Estate Specialist'
  }
];

function RenderCheckbox(props) {
  const { input, meta, ...checkboxProps } = props;
  const checked =
    (input.value && input.value.length === 0 && props.value === '') ||
    (input.value.indexOf && input.value.indexOf(props.value) !== -1);
  return (
    <Checkbox
      {...checkboxProps}
      checked={checked}
      onChange={e => {
        const { checked } = e.target;

        var newValue = [].concat(input.value);

        if (checked && props.value === '') {
          newValue = [];
        } else if (checked && newValue.indexOf(props.value) === -1) {
          newValue.push(props.value);
        } else {
          newValue = without(newValue, props.value);
        }

        if (newValue.indexOf('') !== -1) {
          newValue = without(newValue, '');
        }

        return input.onChange(newValue);
      }}
    />
  );
}

class DesignationFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const labelClassName = `${BS.justifyContentStart} ${BS.mb1} ${BS.alignItemsStart}`;
    const { className, numCols, numInnerCols, ...props } = this.props;
    const colSize = Math.ceil(12 / numCols);
    const colInnerSize = Math.ceil(12 / numInnerCols);
    const numPerCol = Math.ceil(checkboxes.length / numCols);
    const numPerInnerCol = Math.ceil(numPerCol / numInnerCols);

    var i = 0;

    return (
      <Row className={className}>
        {range(numCols).map(col => {
          return (
            <Col key={col} sm={colSize}>
              <FormGroup>
                <Row>
                  {range(numInnerCols).map(innerCol => {
                    return (
                      <Col key={innerCol} sm={colInnerSize}>
                        {range(numPerInnerCol).map(() => {
                          const data = checkboxes[i];
                          i++;
                          return data ? (
                            <RenderCheckbox
                              {...props}
                              key={i}
                              className={labelClassName}
                              value={data.value !== undefined ? data.value : data}
                              label={data.label || data}
                            />
                          ) : null;
                        })}
                      </Col>
                    );
                  })}
                </Row>
              </FormGroup>
            </Col>
          );
        })}
      </Row>
    );
  }
}

DesignationFilter.defaultProps = {
  numCols: 3,
  numInnerCols: 2
};

export default DesignationFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/designation-filter.js